import { openDB } from 'idb'

// Tiny IndexedDB cache for ingested book text. Reading the same book
// repeatedly shouldn't hammer storage + signed-URL minting on every
// open, and offline reading is a basic expectation once the text is
// downloaded. Single-store key-value: bookId → text.

const DB_NAME = 'phoenix-reading'
const DB_VERSION = 1
const STORE = 'book-text'

let dbPromise = null
function getDb() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE)) {
          db.createObjectStore(STORE)
        }
      },
    })
  }
  return dbPromise
}

export async function getCachedText(bookId) {
  if (!bookId) return null
  try {
    const db = await getDb()
    return (await db.get(STORE, bookId)) || null
  } catch {
    return null
  }
}

export async function setCachedText(bookId, text) {
  if (!bookId || typeof text !== 'string') return
  try {
    const db = await getDb()
    await db.put(STORE, text, bookId)
  } catch {
    /* ignore — cache is best-effort */
  }
}

export async function clearCachedText(bookId) {
  if (!bookId) return
  try {
    const db = await getDb()
    await db.delete(STORE, bookId)
  } catch {
    /* ignore */
  }
}
